/**
 * #978 — an in-flight partner reply must not sit as a silent empty bubble.
 * Render-only. Do not write this string into message.content — onDelta
 * would then glue it onto the real reply.
 */

export const STREAMING_REPLY_WAIT = 'Writing a reply…';

export function isEmptyStreamingReply(message) {
  return Boolean(message?.streaming) && !String(message?.content || '').trim();
}

/**
 * Chat rows and stream payloads are supposed to be strings. A partial
 * or failed row can arrive as null or an object; rendering that used to
 * throw and take the thread down. Non-text shapes become an empty string.
 */
export function asChatText(content) {
  if (typeof content === 'string') return content;
  if (content == null) return '';
  if (typeof content === 'number' || typeof content === 'boolean') return String(content);
  if (typeof content === 'object') {
    if (typeof content.text === 'string') return content.text;
    if (typeof content.content === 'string') return content.content;
  }
  return '';
}

export function streamingReplyDisplay(content, { streaming } = {}) {
  const text = asChatText(content);
  if (streaming && !text.trim()) {
    return STREAMING_REPLY_WAIT;
  }
  if (streaming) return hideUnmatchedMarkers(text);
  return text;
}

/**
 * A streaming reply often ends on an opening ** or __ before the closer
 * arrives. Hide that unmatched marker so the writer does not see raw
 * asterisks. A finished pair stays, so markdown can still render it.
 */
export function hideUnmatchedMarkers(content) {
  let text = String(content || '');
  text = hideOddMarker(text, '**');
  text = hideOddMarker(text, '__');
  return text;
}

function hideOddMarker(text, marker) {
  let count = 0;
  let last = -1;
  let from = 0;
  while (from <= text.length - marker.length) {
    const idx = text.indexOf(marker, from);
    if (idx === -1) break;
    count += 1;
    last = idx;
    from = idx + marker.length;
  }
  if (count % 2 === 0 || last < 0) return text;
  return text.slice(0, last) + text.slice(last + marker.length);
}
